export const typeAccessibility = {
  UNKNOWN_ACCESS: 3,
  ACCESS: 0,
  PARTIAL_ACCESS: 1,
  SUPPORT_ACCESS: null,
  NO_ACCESS: 2,
};
    